import { createAction, props } from '@ngrx/store';

import { Device } from '@store/state/devices.state';

export const loadDevices = createAction('[Device] Load Devices');
export const loadDevicesSuccess = createAction(
  '[Device] Load Devices Success',
  props<{ devices: Device[] }>(),
);

export const loadDeviceModels = createAction('[Device] Load Device Models');
export const loadDeviceModelsSuccess = createAction(
  '[Device] Load Device Models Success',
  props<{ deviceModels: { id: number; name: string }[] }>(),
);
export const loadDevicesFailure = createAction(
  '[Device] Load Devices Failure',
  props<{ error: any }>(),
);
export const addDevice = createAction('[Device] Add Device', props<{ device: Device }>());
export const updateDevice = createAction('[Device] Update Device', props<{ device: Device }>());
export const deleteDevice = createAction('[Device] Delete Device', props<{ id: number }>());
